import { lwDispatch } from '../core/livewire.js';
import { escapeHtml } from '../core/config.js';
import { proceed as p, cancel as c } from '../features/scan.js';

window.proceed = p;
window.cancel = c;

/**
 * Result of a scan in the window: a large status in color (allowed: green, allowed again: orange, refused: red), the
 * person, the actions. Labels translated by the server on #scanBadgeModal (data-label-*).
 */
export function renderScan({ badge, status, message, details = '', allowProceed = true, type = 'SCAN' }) {
    const modal = document.getElementById('scan-modal-body');
    if (!modal) {
        console.error('No modal object found to display scan message.');
        return;
    }

    const labels = document.getElementById('scanBadgeModal')?.dataset || {};
    const label = (name, fallback) => labels[name] || fallback;

    if (badge) {
        const count = badge.scan_count || 0;
        // Allowed (scan.js: 'warning' or 'success'), allowed again (already scanned), refused ('danger')
        const state = status === 'danger' ? 'refused' : (count > 0 ? 'again' : 'allowed');
        const states = {
            allowed: ['bi-check-circle-fill', label('labelAllowed', message || 'Allowed')],
            again: ['bi-arrow-repeat', label('labelAgain', 'Already scanned')],
            refused: ['bi-x-octagon-fill', label('labelRefused', message || 'Forbidden')],
        };
        const [icon, text] = states[state];
        const count_label = count > 0
            ? label('labelScannedTimes', 'Scanned :count times').replace(':count', count)
            : label('labelNeverScanned', "Hasn't been scanned yet");

        modal.innerHTML = `
            <div class="checkin-result checkin-result-${state}" role="status">
                <div class="checkin-result-title"><i class="bi ${icon}" aria-hidden="true"></i><span>${escapeHtml(text)}</span></div>
                ${details ? `<div class="checkin-result-reason">${escapeHtml(details)}</div>` : ''}
            </div>
            <div class="checkin-result-person">
                <div class="checkin-result-name">${escapeHtml(badge.name || '')}</div>
                ${badge.company ? `<div class="checkin-result-company">${escapeHtml(badge.company)}</div>` : ''}
                <span class="pg-chip pg-chip-muted">${escapeHtml(count_label)}</span>
            </div>
            <div class="checkin-result-actions">
                ${allowProceed ? `<button class="btn btn-primary btn-lg w-100 js-proceed" data-uuid="${escapeHtml(badge.uuid)}" data-type="${escapeHtml(type)}">${escapeHtml(label('labelProceed', 'Proceed'))}</button>` : ''}
                <button class="btn btn-secondary btn-lg w-100 js-cancel">${escapeHtml(label('labelCancel', 'Cancel'))}</button>
            </div>
        `;

        // Bind after render (no inline handlers)
        const proceedBtn = modal.querySelector('.js-proceed');
        proceedBtn?.addEventListener('click', () => window.proceed(badge.uuid, type));

        const cancelBtn = modal.querySelector('.js-cancel');
        cancelBtn?.addEventListener('click', () => window.cancel());

        lwDispatch('checkin.scan.success', { scan_status: status, badge_uuid: badge.uuid });
    } else {
        modal.innerHTML = `
            <div class="checkin-result checkin-result-refused" role="status">
                <div class="checkin-result-title"><i class="bi bi-x-octagon-fill" aria-hidden="true"></i><span>${escapeHtml(message)}</span></div>
                ${details ? `<div class="checkin-result-reason">${escapeHtml(details)}</div>` : ''}
            </div>
            <div class="checkin-result-actions">
                <button class="btn btn-secondary btn-lg w-100 js-close">${escapeHtml(label('labelClose', 'Close'))}</button>
            </div>
        `;
        modal.querySelector('.js-close')?.addEventListener('click', () => window.cancel());
        lwDispatch('checkin.scan.error');
    }
}
